import {Fragment, useEffect, useState} from 'react';
import {Trans} from '@common/i18n/trans';
import {Dialog} from '@common/ui/overlays/dialog/dialog';
import {DialogBody} from '@common/ui/overlays/dialog/dialog-body';
import {DialogHeader} from '@common/ui/overlays/dialog/dialog-header';
import {closeDialog, openDialog} from '@common/ui/overlays/store/dialog-store';
import {
  useAddProfile,
  useEditProfile,
  useGetProfiles,
  useSelectProfile,
} from './profile/requests/use-get-profiles';
import {
  AvatarProfile,
  useGetAvatarList,
} from './titles/requests/use-avatar-list';
import {Input} from '@mui/material';
import {TextField} from '@common/ui/forms/input-field/text-field/text-field';
import {FormSelect, Option, Select} from '@common/ui/forms/select/select';
import {Button} from '@common/ui/buttons/button';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import AvatarListDialog from './avatarListDialog';
import {Edit, More} from '@mui/icons-material';
import {useAuth} from '@common/auth/use-auth';
import {useSelectedLocale} from '@common/i18n/selected-locale';

function AddProfileDialog() {
  const {locale} = useSelectedLocale();

  const defaultVals =
    localStorage.getItem('default_profile') &&
    JSON?.parse(localStorage.getItem('default_profile') as string);
  const chosenAvatarStorage = localStorage.getItem('chosenAvatar');

  const [chosenAvatar, setChosenAvatar] = useState<number>(
    defaultVals?.avatarId,
  );
  const [name, setName] = useState<string>(defaultVals?.name ?? '');
  const [profileType, setProfileType] = useState<'kid' | 'teenage' | 'adult'>(
    defaultVals?.age ?? 'teenage',
  );

  const avatarList = useGetAvatarList();
  const addProfile = useAddProfile();
  const selectProfile = useSelectProfile();
  const editProfile = useEditProfile(defaultVals?.id);

  useEffect(() => {
    //@ts-expect-error
    setChosenAvatar(chosenAvatarStorage);
  }, [chosenAvatarStorage]);

  return (
    <Dialog>
      <DialogHeader
        onDismiss={() => {
          localStorage.setItem('default_profile', '');
          localStorage.setItem('chosenAvatar', '');
          closeDialog(AddProfileDialog);
        }}
      >
        <span className="text-base">
          <Trans message="Add Profile" />
        </span>
      </DialogHeader>
      <DialogBody className="w-full">
        <div className="max-w-400">
          <span className="text-base">
            <Trans message="Add a profile for your account" />
          </span>
          <div className="mt-[20px] space-y-[10px]">
            {avatarList?.data?.find(ava => ava.id == chosenAvatar) ? (
              <div className="relative">
                <img
                  className="mx-auto h-[150px] w-[150px] rounded-full bg-cover"
                  src={
                    avatarList?.data?.find(ava => ava.id == chosenAvatar)?.url
                  }
                  alt=""
                  onClick={() => openDialog(AvatarListDialog)}
                />
                <Edit
                  className="absolute right-1/3"
                  fontSize="medium"
                  onClick={() => openDialog(AvatarListDialog)}
                />
              </div>
            ) : (
              <div
                className="mx-auto flex h-[150px] w-[150px] items-center justify-center rounded-full border bg-cover"
                onClick={() => openDialog(AvatarListDialog)}
              >
                <Edit fontSize="large" />
              </div>
            )}
            {/* <div className="flex flex-wrap gap-[10px]">
              {avatarList?.data
                ?.slice(0, 5)
                ?.map(avatar => (
                  <img
                    className={`h-[100px] w-[100px] rounded-full bg-cover ${chosenAvatar === avatar.id ? 'border border-white' : ''}`}
                    src={avatar?.url}
                    alt=""
                    onClick={() => setChosenAvatar(avatar.id)}
                  />
                ))}
              <Button
                variant={'raised'}
                className="flex cursor-pointer items-center gap-4"
                onClick={() => openDialog(AvatarListDialog)}
              >
                <span>
                  <Trans message="More Avatars" />
                </span>
                <More />
              </Button>
            </div> */}
            <TextField
              label={<Trans message="Name" />}
              value={name}
              onChange={e => setName(e.target.value)}
            />
            <Select
              name="profileType"
              selectionMode="single"
              label={<Trans message="Age" />}
              showSearchField={false}
              className="flex-1"
              selectedValue={profileType}
              onSelectionChange={(value: any) => {
                setProfileType(value);
              }}
            >
              <Option value={'kid'}>
                <Trans message={'Under 12 (Kid)'} />
              </Option>
              <Option value={'teenage'}>
                <Trans message={'Between 12 And 18 (Teenage)'} />
              </Option>
              <Option value={'adult'}>
                <Trans message={'Above 18 (Adult)'} />
              </Option>
            </Select>
            <Button
              className="mt-[30px] !h-[35px] w-full disabled:!border-none disabled:!bg-toast"
              size="md"
              variant="flat"
              color="primary"
              disabled={addProfile.isPending}
              onClick={() => {
                if (defaultVals?.name) {
                  editProfile.mutate(
                    {
                      type: profileType,
                      avatar_id: chosenAvatar,
                      name,
                    },
                    {
                      onSuccess: res => {
                        localStorage.setItem('default_profile', '');
                        closeDialog(AddProfileDialog);
                        toast(message('Profile Edited SuccessFully'));
                      },
                    },
                  );
                } else {
                  addProfile.mutate(
                    {
                      type: profileType,
                      avatar_id: chosenAvatar,
                      name,
                    },
                    {
                      onSuccess: res => {
                        localStorage.setItem('default_profile', '');
                        selectProfile.mutate(res.profile.id);
                        closeDialog(AddProfileDialog);
                        toast(message('Profile Added SuccessFully'));
                      },
                    },
                  );
                }
              }}
            >
              <Trans message="Submit" />
            </Button>

            <p className={`text-justify leading-7`}>
              {locale?.language === 'fa' ? (
                <Fragment>
                  <p>پروفایل کودک در MdbMax چیست؟</p>
                  <p>
                    سایت MdbMax اطمینان حاصل می‌کند که در پروفایل کودک فقط
                    محتوای مناسب برای سنین زیر ۱۲ سال نمایش داده شود.{' '}
                  </p>
                  <p>
                    در پروفایل‌های کودک، فقط برنامه‌های تلویزیونی و فیلم‌هایی که
                    رده‌بندی سنی آن‌ها ۱۲ سال و کمتر است نمایش داده می‌شوند.
                    همچنین، نتایج جستجو و پیشنهادهای جستجو نیز با توجه به سن
                    فیلتر می‌شوند.{' '}
                  </p>
                  <p>
                    برای اینکه کودکان نتوانند به راحتی به پروفایل بزرگسالان
                    سوئیچ کنند و به محتوای نامناسب دسترسی پیدا کنند، می‌توانید
                    پروفایل‌های بزرگسال را با رمز PIN قفل کنید. همچنین،
                    می‌توانید امکان ایجاد یا حذف پروفایل را محدود کنید تا کودکان
                    نتوانند با ساختن پروفایل جدید، محدودیت‌ها را دور بزنند.{' '}
                  </p>
                </Fragment>
              ) : (
                <Fragment>
                  <p>What is a Kids Profile on MdbMax?</p>
                  <p>
                    MdbMax ensures that only age-appropriate content for
                    children under 12 is shown in a Kids Profile.{' '}
                  </p>
                  <p>
                    In Kids Profiles, only TV shows and movies rated for ages 12
                    and under are displayed. Search results and search
                    suggestions are also filtered based on the child's age.{' '}
                  </p>
                  <p>
                    To prevent children from easily switching to adult profiles
                    and accessing inappropriate content, you can lock adult
                    profiles with a PIN code. Additionally, you can restrict the
                    ability to create or delete profiles to stop children from
                    bypassing limitations by creating new profiles.{' '}
                  </p>
                </Fragment>
              )}
            </p>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
}

export default AddProfileDialog;
